import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { SectionBoxedText } from 'app/core/cms/generated/api-types'
import { LexicalRichTextDirective } from 'app/shared/richtext/lexical-rich-text.directive'

import { CmsBlock } from '../../cms-block'
import { parseDesign } from '../section-utils'

@Component({
  selector: 'pai-section-boxed-text',
  templateUrl: './section-boxed-text.component.html',
  styleUrls: ['./section-boxed-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.size]': 'design().containerWidth',
    '[attr.background]': 'design().background',
    '[attr.innerShadow]': 'design().innerShadow',
  },
  imports: [LexicalRichTextDirective],
  providers: [{ provide: CmsBlock, useExisting: SectionBoxedTextComponent }],
})
export class SectionBoxedTextComponent extends CmsBlock<SectionBoxedText> {
  readonly __typename = 'SectionBoxedText'
  protected readonly design = computed(() => parseDesign(this.data().design))
}
